import React from 'react';
import { Paperclip, Send, Mic, MicOff } from 'lucide-react';
import { Button } from '../ui/button';

interface ChatControlsProps {
  onFileUpload: () => void;
  onSendMessage: () => void;
  isListening: boolean;
  onStartListening: () => void;
  onStopListening: () => void;
  isSendDisabled: boolean;
  messageLength: number;
}

export const ChatControls: React.FC<ChatControlsProps> = ({
  onFileUpload,
  onSendMessage,
  isListening,
  onStartListening,
  onStopListening,
  isSendDisabled,
  messageLength,
}) => {
  return (
    <div className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center gap-2">
      <Button 
        variant="ghost" 
        size="icon" 
        className="icon-button"
        onClick={onFileUpload}
        title="Прикрепить файл"
      >
        <Paperclip className="h-5 w-5" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className="icon-button"
        onClick={isListening ? onStopListening : onStartListening}
        title={isListening ? "Остановить запись" : "Начать запись"}
      >
        {isListening ? (
          <MicOff className="h-5 w-5 text-primary" />
        ) : (
          <Mic className="h-5 w-5" />
        )}
      </Button>
      <Button 
        variant="ghost" 
        size="icon" 
        className="icon-button"
        onClick={onSendMessage}
        disabled={isSendDisabled}
        title="Отправить сообщение"
      >
        <Send className="h-5 w-5" />
      </Button>
    </div>
  );
};